/**
 * The response is returned as HTML, this function parses into a more usable
 * format
 *
 * @param  {Object} json ajax response json
 * @param cart_checkout_url
 * @return {Object}      products, prices, & checkoutUrl
 *
 * products = [{
 *   langName: string,
 *   prodType: string,
 *   level: string,
 *   image: string
 * }, ...]
 */
const parseResponse = (json, cart_checkout_url) => {
    const navTotalPrices = json.cartInfo;
    // gather cart data into navTotals
    if (navTotalPrices !== null && json.itemInfo !== null) {
        const navTotalProducts = json.itemInfo.map((item) => ({
            langName: item.language,
            prodType: item.type === "Online Sub" ? "Online Subscription" : item.type,
            level: `${Number(item.sub_month)} Months`,
            image: ""
        }));
        const { count } = json;
        return {
            products: navTotalProducts,
            prices: navTotalPrices,
            checkoutUrl: cart_checkout_url,
            count
        };
    }
    return {
        products: 0,
        prices: 0,
        checkoutUrl: cart_checkout_url,
        count: 0
    };
};

module.exports = { parseResponse };
